/**
 * logout header widget
*/
/* eslint-disable */
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Avatar from '@material-ui/core/Avatar';
import { Link, withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { logout } from "../../../actions/action";


class Logout extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
           anchorEl: null,
           userImage: {
               url: require('../../../assets/avatars/user-4.jpg'),
               alt: 'user'
           },
           menus: [
               {
                   id: 1,
                   title: 'Profile',
                   icon: 'account_circle',
                   path: '/account/profile'
               },
               {
                   id: 2,
                   title: 'Account',
                   icon: 'settings',
                   path: '/account/profile'
               },
               {
                   id: 3,
                   title: 'Message',
                   icon: 'email',
                   path: '/account/profile'
               },
               {
                   id: 4,
                   title: 'Logout',
                   icon: 'power_settings_new',
                   func: this.logout
               }
           ]
      };
   }


   logout = () => {
      this.props.logout();
      window.location.href = '/sign-in';
   }
   //define function for open dropdown
   handleMenu = event => {
      this.setState({ anchorEl: event.currentTarget });
   };

   //define function for close dropdown
   handleClose = (func) => {
      this.setState({ anchorEl: null });

      if (func && typeof func === 'function') {
         func()
      }
   };

   render() {
      const { user }  = this.props;
      const { anchorEl } = this.state;
      const open = Boolean(anchorEl);
      const userImage = this.state.userImage;

      return (
         <div className='iron-logout-wrap'>
            <div className="d-flex align-items-center base-text" onClick={this.handleMenu}>
               <Avatar
                  aria-owns={open ? 'menu-appbar' : null}
                  aria-haspopup="true"
                  className="icon-btn"
                  alt={userImage.alt} src={userImage.url}
               >
               </Avatar>
               <span className="pl-10 clickable">Welcome, {user && user.name || ''}</span>
            </div>
            <Menu
               anchorEl={anchorEl}
               anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
               }}
               transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
               }}
               open={open}
               onClose={this.handleClose}
               className="iron-dropdown"
            >
               {this.state.menus.map((menu, index) => (
                  <MenuItem
                     key={index}
                     onClick={() => this.handleClose(menu.func)}
                     to={menu.path}
                     component={menu.path ? Link : null}
                  >
                     <i className="material-icons">{menu.icon}</i>
                     <span className="mb-0">{menu.title}</span>
                  </MenuItem>
               ))}
            </Menu>
         </div>
      );
   }
} 

const mapStateToProps = ({ appSettings }) => {
   const { user } = appSettings;
   return { user };
};

export default withRouter(connect(mapStateToProps, {
    logout,
})(Logout));


// WEBPACK FOOTER //
// ./src/components/layouts/headers/Logout.js